import styled, { StyledComponent } from '@emotion/styled';
import { Typography as MuiTypography, TypographyProps } from '@mui/material';

// TODO: refactor without type assertion, or add comment
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const Typography: StyledComponent<TypographyProps> = styled(
  MuiTypography,
)`
  & * {
    font-family: inherit;
  }
` as any;
